import { render, staticRenderFns } from "./DevComponentPrototype.vue?vue&type=template&id=755f1410&scoped=true"
import script from "./DevComponentPrototype.vue?vue&type=script&lang=js"
export * from "./DevComponentPrototype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755f1410",
  null
  
)

export default component.exports